import { gql } from '@apollo/client';

export const FETCH_UTILITY_CONNECT_TOKEN = gql`
  query Flex_FetchUtilityConnectToken($utilityCredentialId: Int!) {
    utilityCredentialConnectToken(id: $utilityCredentialId)
  }
`;
